/* BOLODOO desktop floating colors v1 */
/* BOLODOO mobile floating colors v1 */
function initBolodooFloatingColors(form) {
  const popup = form.closest('.product__popup');
  // Submit the canonical form: the floating clone does not own size/custom properties.
  if (!form.dataset.bfcSubmitBound) {
    form.dataset.bfcSubmitBound = 'true';
    form.addEventListener('submit', event => {
      
      event.preventDefault();
      event.stopImmediatePropagation();
      const main = document.getElementById('ProductInfo-' + popup?.dataset.sectionId);
      const button = main?.querySelector('.product-form__submit');
      if (button && !button.disabled && button.getAttribute('aria-disabled') !== 'true') button.click();
    }, true);
  }
  const text = popup?.querySelector('.product_info .text');
  const field = () => form.querySelector('.product-form__controls--colors');
  if (!text || !field() || text.querySelector('.bfc-trigger')) return;
  const trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'bfc-trigger';
  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.setAttribute('aria-expanded', 'false');
  const name = document.createElement('span');
  trigger.append(name);
  text.append(trigger);
  const sync = () => {
    const selected = field()?.querySelector('input:checked + label');
    name.textContent = selected?.getAttribute('data-color') || selected?.title || field()?.querySelector('.product-options-name')?.textContent.trim() || 'Color';
    trigger.setAttribute('aria-label', 'Choose color, current color: ' + name.textContent);
  };
  sync();
  form.addEventListener('change', () => requestAnimationFrame(sync));
  trigger.addEventListener('click', () => {
    
    sync();
    const originals = [...(field()?.querySelectorAll('label.variant-swatch, a.linked-product-swatch') || [])];
    if (!originals.length) return;
    const dialog = document.createElement('dialog');
    dialog.className = 'bfc-dialog';
    dialog.setAttribute('aria-label', 'Choose color');
    const head = document.createElement('div');
    head.className = 'bfc-head';
    const title = document.createElement('h2');
    title.textContent = 'Choose color';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'bfc-close';
    close.setAttribute('aria-label', 'Close color selection');
    close.title = 'Close';
    close.addEventListener('click', () => dialog.close());
    head.append(title, close);
    const grid = document.createElement('div');
    grid.className = 'bfc-grid';
    for (const original of originals) {
      const input = original.control;
      const current = Boolean(input?.checked || original.getAttribute('aria-current') === 'true');
      const color = original.getAttribute('data-color') || original.title || original.getAttribute('aria-label') || input?.value || 'Color';
      const choice = document.createElement(original.tagName === 'A' ? 'a' : 'button');
      choice.className = 'bfc-choice';
      if (original.tagName === 'A') {
        choice.href = original.href;
        choice.dataset.bolodooProductColorLink = '';
      }
      else {
        choice.type = 'button';
        choice.disabled = Boolean(input?.disabled);
        choice.setAttribute('aria-pressed', String(current));
        choice.addEventListener('click', () => { original.click(); sync(); dialog.close(); });
      }
      if (current) choice.classList.add('is-current');
      const image = document.createElement('span');
      image.className = 'bfc-image';
      image.style.backgroundImage = original.style.backgroundImage;
      image.style.backgroundColor = original.style.backgroundColor;
      image.setAttribute('aria-hidden', 'true');
      const caption = document.createElement('span');
      caption.textContent = color;
      choice.append(image, caption);
      grid.append(choice);
    }
    dialog.append(head, grid);
    document.body.append(dialog);
    const media = matchMedia('(max-width: 989px)');
    const resize = () => dialog.close();
    media.addEventListener('change', resize);
    const oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = oldOverflow;
      media.removeEventListener('change', resize);
      trigger.setAttribute('aria-expanded', 'false');
      dialog.remove();
      trigger.focus({preventScroll: true});
    }, {once: true});
    dialog.addEventListener('click', event => {
      const bounds = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    });
    trigger.setAttribute('aria-expanded', 'true');
    dialog.showModal();
  });
}

(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
      }
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector(
      ".product-media-modal__content"
    );
    const images = imagesWrapper.querySelectorAll(".js-image-zoom");

    images.forEach((el) => {
      el.addEventListener("click", (e) => {
        imagesWrapper.classList.toggle("zoom");
      });
    });
  };

  const revealPopup = () => {
    const stickyBar = document.querySelector(".product__popup"); // Sticky bar
    const secondSection = document.querySelector(".product-section + section"); // Second section
    const secondShopifySection = document.querySelector(".product-section + .shopify-section"); // Second shopify section
    const footer = document.querySelector("footer"); // Footer

    // Check if the required elements exist
    if (!stickyBar || !(secondSection || secondShopifySection) || !footer) {
      console.error("Required elements not found!");
      return;
    }

    const getOffset = (element) => {
      const rect = element.getBoundingClientRect();
      return rect.top + window.scrollY;
    };

    const secondSectionMid = getOffset(secondSection || secondShopifySection);
    const footerTop = getOffset(footer);

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const activeOffset =
        window.scrollY > secondSectionMid && scrollPosition < footerTop;

      stickyBar.classList[activeOffset ? "add" : "remove"]("active");
    };

    // Initial check in case the user starts in the middle of the page
    handleScroll();
  };

  document.addEventListener("scroll", () => revealPopup());

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
    initZoomImage();
    revealPopup();
  });

  initProductAccordion();
  initZoomImage();
  revealPopup();

  const syncPairedQuantity = (event) => {
    const input = event.target;
    if (!input.classList?.contains("quantity__input")) return;

    const match = input.id.match(/^Quantity-(?:(floated)-)?(.+)$/);
    if (!match) return;

    const pairedId = match[1]
      ? `Quantity-${match[2]}`
      : `Quantity-floated-${match[2]}`;
    const pairedInput = document.getElementById(pairedId);
    if (!pairedInput || pairedInput.value === input.value) return;

    pairedInput.value = input.value;
    pairedInput.closest("quantity-input")?.setMinimumDisable();
  };

  document.addEventListener("change", syncPairedQuantity);
})();

class FloatedForm extends HTMLElement {
  constructor() {
    super();
    this.renderForm();
  }

  renderForm() {
    fetch(this.getAttribute("data-product-url"))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        this.productElement = responseHTML.querySelector(
          'div[id^="ProductInfo-"]'
        );

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this, this.productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.showMoreFields();
        initBolodooFloatingColors(this);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `floated-${sectionId}`
    );

    if (this.productElement.querySelectorAll("variant-selects")) {
      this.productElement
        .querySelectorAll("variant-selects")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }

    if (this.productElement.querySelectorAll("variant-radios")) {
      this.productElement
        .querySelectorAll("variant-radios")
        .forEach((radio) => {
          radio.dataset.originalSection = sectionId;
        });
    }
  }

  removeDOMElements() {
    // BOLODOO real-life floating exclusion v1
    this.productElement.querySelectorAll('real-life-media').forEach(element => element.remove());

    // BOLODOO floating cart filter v2: these blocks stay on the product page, but not in the floating cart.
    const relatedStyles = this.productElement.querySelector(".product-related-styles");
    if (relatedStyles) relatedStyles.remove();

    const shippingProtectionBlocks = [...this.productElement.querySelectorAll(".shopify-app-block, [id^=\"shopify-block-\"], [id*=\"xcotton\" i], [class*=\"xcotton\" i], [id*=\"xcover\" i], [class*=\"xcover\" i]")].filter((element) => {
      const attributes = [
        element.id,
        typeof element.className === "string" ? element.className : "",
        element.getAttribute("data-block-handle"),
        element.getAttribute("data-block-type"),
        element.textContent,
      ].filter(Boolean).join(" ");
      return /xcotton|xcover|shipping[- _]?protection/i.test(attributes);
    });
    shippingProtectionBlocks.forEach((element) => {
      const appBlock = element.closest(".shopify-app-block, [id^=\"shopify-block-\"]");
      (appBlock || element).remove();
    });

const text = this.productElement.querySelector(".product__text");
    if (text) text.remove();

    const tags = this.productElement.querySelector(".product__tags");
    if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
    if (title) title.remove();

    const badges = this.productElement.querySelector(".product__custom-badges");
    if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
    if (price) price.remove();

    const description = this.productElement.querySelector(
      ".product__description"
    );
    if (description) description.remove();

    const sku = this.productElement.querySelector(".product__sku");
    if (sku) sku.remove();

    const inventory = this.productElement.querySelector(".product__inventory");
    if (inventory) inventory.remove();

    const pickupAvailability = this.productElement.querySelector(
      "pickup-availability"
    );
    if (pickupAvailability) pickupAvailability.remove();

    const customLiquid = this.productElement.querySelector(".custom-liquid");
    if (customLiquid) customLiquid.remove();

    const complementary = this.productElement.querySelector(
      "product-recommendations"
    );
    if (complementary) complementary.remove();

    const shareButtons = this.productElement.querySelector(".share-buttons");
    if (shareButtons) shareButtons.remove();

    const productModal = this.productElement.querySelectorAll(".product-popup");
    productModal.forEach((advantage) => {
      advantage.remove();
    });

    const productForm = this.productElement.querySelector("floated-form");
    if (productForm) productForm.remove();
  }

  showMoreFields() {
    $(".js-show-more").click(function (e) {
      e.preventDefault();
      $(this).siblings("input").removeClass("hidden");
      $(this).siblings("label").removeClass("hidden");
      $(this).remove();
    });
  }
}

customElements.define("floated-form", FloatedForm);
